export enum EDashboardDetailType {
    WorkingEmployee,
    ApproachingOT,
    OT
}